import { alert } from "./alertManager";
import { errorNotification } from "./notificationManager";

/**
 * Muestra una alerta según el código de error HTTP y un mensaje personalizado.
 * @param {Object} error - Objeto de error recibido de una respuesta HTTP.
 * @param {string} message - Mensaje personalizado a mostrar para ciertos errores.
 */
export const errorHTTP = (error, message) => {
    const status = error.response?.status;

    switch (status) {
        case 401:
            alert("Error", "Token inválido o caducado. Inicia sesión de nuevo.", "error");
            break;
        case 403:
            alert("Error", "Acceso no autorizado.", "error");
            break;
        case 404:
        case 409:
            alert("Error", message, "error");
            break;
        default:
            errorNotification("Ocurrió un error en el servidor.");
    }
};

/**
 * Maneja errores de API automáticamente mostrando mensajes adecuados según el código HTTP.
 * @param {Object} error - Objeto de error recibido de una petición Axios.
 */
export const handleApiError = (error) => {
    const status = error.response?.status;

    if (status) {
        switch (status) {
            case 401:
                alert("Error", "Token inválido o caducado. Inicia sesión de nuevo.", "error");
                break;
            case 403:
                alert("Error", "Prohibido. No tienes permiso para acceder a este recurso.", "error");
                break;
            case 404:
            case 409:
                alert("Error", error.response.data?.data?.message || "Ocurrió un error.", "error");
                break;
            case 500:
                alert("Error", "Error interno del servidor. Inténtalo de nuevo más tarde.", "error");
                break;
            default:
                alert(`Error ${status}`, error.response.statusText || "Error desconocido", "error");
        }
    } else {
        console.error("Error al cargar los datos:", error.message);
    }
};